import HttpRequest from './HttpRequest';

export const getDissertations = async () => {
  try {
    const response = await HttpRequest.get('/dissertations');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};
